import { IAddress, IError, IQueryHookOptions } from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { releaseFulfillments } from 'services';

type ReleaseFulfillmentsFunction = UseMutateAsyncFunction<
  boolean,
  IError,
  Partial<IAddress>
>;

type UseReleaseFulfillments = [ReleaseFulfillmentsFunction, IQueryHookOptions];

export const useReleaseFulfillments = (id = ''): UseReleaseFulfillments => {
  const queryClient = useQueryClient();
  const { error, isError, isLoading, mutateAsync } = useMutation<
    boolean,
    IError,
    Partial<IAddress>
  >((values: Partial<IAddress>) => releaseFulfillments(id, values), {
    onSuccess: () => {
      queryClient.invalidateQueries('hasPendingFulfillments');
    },
  });

  return [mutateAsync, { error, isError, isLoading }];
};
